import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { messagingActions } from './messagingSlice';
import { EventTypes } from '../constants/event';
import { Languages, LANGUAGES } from '../utils/constants';

export interface LanguageState {
  currentLanguage: Languages;
}

const initialState: LanguageState = {
  currentLanguage: LANGUAGES.ENGLISH,
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Languages>) => {
      state.currentLanguage = action.payload;
    },
    toggleLanguage: (state) => {
      state.currentLanguage =
        state.currentLanguage === LANGUAGES.ENGLISH
          ? LANGUAGES.SPANISH
          : LANGUAGES.ENGLISH;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(messagingActions.messageReceived, (state, action) => {
      const { messages = [], ai, sessionBoundarySessionId } = action.payload;
      messages.forEach((message) => {
        if (message.event === EventTypes.carEnter) {
          state.currentLanguage = LANGUAGES.ENGLISH;
        }
      });
    });
  },
});

export const { setLanguage, toggleLanguage } = languageSlice.actions;
export default languageSlice.reducer;
